const commonTheme = {
    global: {
        text: "#222",
        background: "#fff",
        border: "#f0f0f0"
    },
    sidebar: {
        bg: "#fff",
        text: "#222",
        icon: "#666",
        select: "#ec1c2a",
        bgSelect:"#ffedeb",
        borderTopAB: "rgba(145, 158, 171, 0.8)",
        bt: "#fff",
        bR: "#f0f0f0",
        avatar: "#121024",
    },
    sidebarOrgSetting: {
        bg: "#08062c",
        text: "#fff",
        icon: "#rgb(33, 31, 65)",
        select: "#221f41",
        bgSelect: "#221f41",
    },
    sidebarFolderSetting: {
        bg: "#08062c",
        text: "#fff",
        icon: "#rgb(33, 31, 65)",
        select: "#ec1c2a",
        bgSelect: "#221f41",
        copy: "rgba(0, 0, 0, 0.34)",
    },
    headbar: {
        btnMenu: '#EC1C2A'
    },
    folders: {
        text: "#222",
        textHover: "#222426",
        folderCardBg: "#f5f6f9",
        folderCardText: "#222",
        folderCardSubText: "#666",
        folderCardIcon: "#666",
        folderCardBorder: "#F5F6F9",
        itemHover: "#e1e5ea",
    },
    folderDetail: {
        curFol: "#222",
        bgColorHeader: "#fff",
        text: "#222",
        
        //Badge
        borderColor: "#ec1c2a",
        colorTabDefault: 'rgba(0,0,0,0.85)', 
        bgColorCountNonSelected: '#ffffff', 
        
        //Search
        bgSearch: '#fff',
        borderSearch: '#e5e5e5',
        
        //Footer
        bgFooter: '#fff',
    },
    SubmissionDrawer: {
        text: "#222",  
        border: "#00000012",
        hover: "#F5F6F9",
        iconCheck: "#rgba(0, 0, 0, 0.25)",
    },
    submissionData: {
        text: "#222",
        btnRatio: "#1f1f1f",
        bgTopbar: '#ffffff',
        btnTopbar: '#222',
        datapointLabel: '#222',

        bgDocumentImage: '#f5f6f9',

        //Table Footer
        bgTableFooter: '#ffffff',
        iconDelete: 'rgba(0, 0, 0, 0.24)',
        borderTable: "#f0f0f0"
    },
    pricing: {
        bgCardPrice: "fff",
        text: "#222",
    },
    review: {
        text: "#222",
        bgField: "#dfe3e8",
        bgMain: "#f5f6f9",
        btn: "#000",
        bgDiff: "#e0e0e0ff",
        borderDiff: "#d1d5da",
    },
    statistic: {
        text: "#222",
        background: "#fff",
        border: 'rgba(240, 240, 240, 1)'
    },
// AtnD Config Theme
    pagination: {
        bgColorDefault: "#ffffff",
        borderColorDefault: '#d9d9d9',
        colorTextDefault: '#000000',
        
        bgColorHover: '#fff',
        borderColorHover: '#ec1c2a',
        colorTextHover: '#ec1c2a',

        bgColorActive: '#ec1c2a',
        colorTextActive: '#fff',
    },
    table: {
        bgColor: '#ffffff',
        bgColorHeader: '#f5f6f9',
        borderColor: '#f0f0f0',

        colorTextHeader: '#000000',
        colorTextBody: '#000000',

        bgColorHover: '#f5f5f5',
        bgColorStripe: '#ffffff',   

        bgSkipRow: '#fff0f0',

        bgColorSelected: "#ffedeb"
    },
    input: {
        bgColorDefault: '#ffffff',      
        borderColorDefault: 'rgb(240, 240, 240)',  
        colorTextDefault: '#000000',    

        colorPlaceholder: '#bfbfbf', 

        borderColorFocus: '#ec1c2a',     
        boxShadowFocus: '0 0 0 2px rgba(24, 144, 255, 0.2)',
        
        bgColorDisabled: '#f5f5f5',      
        colorTextDisabled: 'rgba(0, 0, 0, 0.25)',
    },
    drawer: {
        bgColor: '#ffffff',
        bgColorHeader: '#ffffff',
        colorText: '#000000',
        colorCloseIcon: 'rgba(0, 0, 0, 0.45)',
        borderColor: '#f0f0f0',
    },
    select:{
        bgColorDefault: '#ffffff',      
        borderColorDefault: '#d9d9d9',  
        colorTextDefault: '#000000',    

        colorPlaceholder: '#bfbfbf', 

        borderColorFocus: '#ec1c2a',     
        
        bgColorDropdown: '#ffffff',      
        bgColorOptionHover: '#f5f5f5',   
        bgColorOptionSelected: '#ffedeb',
        bgSelectedItem: '#f5f5f5',
        colorTextOptionSelected: '#000000',
    },
    btn: {
        defaultBgColor: '#ffffff',
        defaultTextColor: '#2b2b2b',
        defaultBorderColor: '#e9e9e9',
        defaultHoverBgColor: '#ffffff',
        defaultHoverBorderColor: '#ec1c2a',
        defaultHoverTextColor: '#ec1c2a',

        primaryBgColor: '#ec1c2a',
        primaryTextColor: '#fff',
        primaryBorderColor: '#ec1c2a',
        primaryHoverBgColor: '#ef4954', 
        primaryHoverBorderColor: '#ef4954',

        textHoverBgColor: '#f5f5f5',
    },
    dropdown: {
        bgColorDropdown: '#ffffff',      
        colorTextDefault: '#000000',
        bgColorOptionHover: '#f5f5f5',   
    },
    spin: {
        colorBgContainer: '#ffffff',
    },
    datepicker: {
        bgColorDefault: '#ffffff',      
        borderColorDefault: 'rgb(240, 240, 240)',  
        colorTextDefault: '#000000',    
        colorPlaceholder: '#bfbfbf', 
        borderColorFocus: '#ec1c2a',     
        bgColorDisabled: '#f5f5f5',      
        colorTextDisabled: 'rgba(0, 0, 0, 0.25)',
        separatorColor: 'rgba(0, 0, 0, 0.45)', 
        panelBg: '#ffffff', 
        bgHover: '#f5f5f5',
    },
    popover: {
        bgColor: '#ffffff',
        colorText: '#000000',
        borderColor: 'rgb(240, 240, 240)',
        titleBottomBorder: '#f0f0f0',
        hover: '#f5f5f5'
    },
    modal: {
        bgColor: '#ffffff',
        colorText: '#000000',
        borderColor: '#f0f0f0',
        maskBg: 'rgba(0, 0, 0, 0.45)',
        closeIconColor: 'rgba(0, 0, 0, 0.45)',
    }
};  

export default commonTheme;